module.exports = __webpack_public_path__ + "img/play-btn-icon.5666076d.svg";